import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { BaseBulkItemDataFragment } from '../../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../../elements/intl/custom-formatted-message';
import { BulkMessagesListItem } from './bulk-messages-list-item';

type BulkMessagesListProps = {
  dataLoading?: boolean;
  loading?: boolean;
  items: BaseBulkItemDataFragment[];
  onClick?: (value: BaseBulkItemDataFragment) => void;
  onAddPatients?: (value: BaseBulkItemDataFragment) => void;
  onAddSlots?: (value: BaseBulkItemDataFragment) => void;
  onSendAll?: (value: BaseBulkItemDataFragment) => void;
};

function BulkMessagesList({
  loading,
  dataLoading,

  items,
  onClick,
  onAddPatients,
  onAddSlots,
  onSendAll,
}: BulkMessagesListProps) {
  const listItems = useMemo(() => items, [items]);

  if (dataLoading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }
  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }
  return (
    <div className="content-list">
      {listItems.map(option => (
        <div key={option.id} className="content-list__item">
          <BulkMessagesListItem
            item={option}
            loading={loading}
            onClick={onClick}
            onAddPatients={onAddPatients}
            onAddSlots={onAddSlots}
            onSendAll={onSendAll}
          />
        </div>
      ))}
    </div>
  );
}

export { BulkMessagesList };
